"use strict";

module.exports = {
  INSPECT: 'INSPECT',
  'INSPECT-V2': 'INSPECT-V2',
  INVENTORY: 'INVENTORY'
};